<div class="svg-container">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1500 1500">
    @for (part of frontBodyParts; track part) {
      <ng-container>
        @for (d of getPaths(part); track d) {
          <ng-container>
            <path [attr.d]="d" [attr.fill]="isFrontSelected(part.slug) ? '#ff5e5e' : part.color" stroke="#333"
              stroke-width="1" style="cursor: pointer" />
              <!-- (click)="onPathClick(part.slug)" -->
            </ng-container>
          }
        </ng-container>
      }

      @for (part of backBodyParts; track part) {
        <ng-container>
          @for (d of getPaths(part); track d) {
            <ng-container>
              <path [attr.d]="d" [attr.fill]="isBackSelected(part.slug) ? '#ff5e5e' : part.color" stroke="#333"
                stroke-width="1" style="cursor: pointer" />
                <!-- (click)="onPathClick(part.slug)" -->
              </ng-container>
            }
          </ng-container>
        }
      </svg>
    </div>